<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <path d="M2 21h20M3 21V9h6m0 12V3h9v18m0-11h3v11M6 12v1m0 3v1m6-11h3m-3 4h3m-3 4h3m-3 7v-3h3v3" />
  </svg>
</template>
